"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _index = _interopRequireDefault(require("@insided/deprecated-control/header/index"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _Credentials = _interopRequireDefault(require("./Credentials"));

var _message = _interopRequireDefault(require("../design-system-components/message"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _List = _interopRequireDefault(require("./List"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _clipboard = _interopRequireDefault(require("../../utils/clipboard"));

var _Section = require("@insided/deprecated-control/ui-components/Section");

var _Table = _interopRequireDefault(require("../table/Table"));

var _ExternalLink = _interopRequireDefault(require("@insided/shared/icons/ExternalLink"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var messageMap = {
  id: 'Client ID copied to your clipboard.',
  secret: 'Client secret copied to your clipboard.'
};

var Form = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Form);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      name: '',
      processing: false,
      message: '',
      messageType: undefined,
      clients: props.clients
    };
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.successResponse = _this.successResponse.bind((0, _assertThisInitialized2.default)(_this));
    _this.errorResponse = _this.errorResponse.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCopy = _this.handleCopy.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // message-container has to be a non-react element beacuse React portal cannot be unmounted without non-react DOM parent, that's why it s created with pure js
      var container = document.querySelector('.oauth2-create-client');
      var messageContainer = document.createElement('div');
      messageContainer.id = 'message-container';
      container === null || container === void 0 ? void 0 : container.appendChild(messageContainer);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      if ((0, _typeGuards.hasValueInEventTarget)(event)) {
        this.setState({
          name: String(event.target.value)
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(evt) {
      evt.preventDefault();
      this.setState({
        validationError: undefined
      });
      var _this$state = this.state,
          processing = _this$state.processing,
          name = _this$state.name;

      if (processing) {
        return;
      }

      if (name === '') {
        this.setState({
          validationError: 'Please fill in the required field.'
        });
        return;
      }

      this.setState({
        processing: true,
        message: '',
        messageType: undefined
      });

      _axios.default.post('/settings/api/clients', {
        name: name
      }).then(this.successResponse).catch(this.errorResponse);
    }
  }, {
    key: "handleRevoke",
    value: function handleRevoke(client) {
      var _this2 = this;

      this.setState({
        message: '',
        messageType: undefined
      });

      _axios.default.post('/settings/api/revoke', {
        client_id: client.id
      }).then(function () {
        _this2.setState(function (prevState) {
          return {
            clients: prevState.clients.filter(function (curr) {
              return curr !== client;
            }),
            message: 'You’ve deleted a client.',
            messageType: 'success'
          };
        });
      }).catch(this.errorResponse);
    }
  }, {
    key: "successResponse",
    value: function successResponse(response) {
      if (!response.data) {
        return;
      }

      var client = response.data; // eslint-disable-next-line react/no-access-state-in-setstate

      var clients = this.state.clients;
      clients.push(client);
      this.setState({
        processing: false,
        credentials: {
          id: client.clientId,
          secret: client.secret
        },
        clients: clients,
        message: 'You’ve created an OAuth2 client.',
        messageType: 'success'
      });
    }
  }, {
    key: "errorResponse",
    value: function errorResponse(error) {
      var message = 'Something went wrong.';
      var response = error.response;

      if (response !== null && response !== void 0 && response.data.message) {
        message = response.data.message;
      }

      this.setState({
        processing: false,
        message: message,
        messageType: 'error'
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Your region',
        accessor: 'region',
        size: 'xs'
      }, {
        header: 'Your API base url',
        accessor: 'apiBaseUrl',
        size: 'm'
      }];
    }
  }, {
    key: "getRows",
    value: function getRows() {
      return [{
        region: (0, _globals.default)('region'),
        apiBaseUrl: this.props.apiBaseUrl
      }];
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.state.validationError === undefined) {
        return;
      }

      this.setState({
        validationError: undefined
      });
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        message: '',
        messageType: undefined
      });
    }
  }, {
    key: "handleCopy",
    value: function () {
      var _handleCopy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(field) {
        var credentials;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                credentials = this.state.credentials;

                if (!(field && credentials)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return (0, _clipboard.default)(credentials[field]);

              case 4:
                this.setState({
                  message: messageMap[field],
                  messageType: 'success'
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCopy(_x) {
        return _handleCopy.apply(this, arguments);
      }

      return handleCopy;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var url = this.props.url;
      var _this$state2 = this.state,
          name = _this$state2.name,
          processing = _this$state2.processing,
          message = _this$state2.message,
          messageType = _this$state2.messageType,
          credentials = _this$state2.credentials,
          clients = _this$state2.clients,
          validationError = _this$state2.validationError;
      var customButtons = [// eslint-disable-next-line react/jsx-key
      (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        size: "medium",
        title: (0, _preact.h)("div", null, "API Documentation ", (0, _preact.h)(_ExternalLink.default, {
          width: 16,
          height: 16,
          className: "external-link-icon"
        })),
        onClick: function onClick() {
          return window.open(url, '_blank');
        }
      })];
      return (0, _preact.h)("section", {
        className: "oauth2-create-client"
      }, messageType && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: messageType,
        onDismiss: this.dismissMessage
      }, message), (0, _preact.h)(_index.default, {
        title: "API",
        customButtons: customButtons,
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("form", {
        onSubmit: this.handleSubmit
      }, (0, _preact.h)(_Section.Section, {
        title: "OAuth2"
      }, credentials && (0, _preact.h)(_Message.Message, {
        variant: "warning"
      }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Make sure you copy and store your Client ID and Client Secret - we won\u2019t show them again after you leave this page. Take care to keep your client credentials secure. Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected or malicious behaviour on your community."))), (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        title: "Label",
        meta: "Use a label as a reminder of why you generated this client.",
        placeholder: "Enter an application name",
        disabled: processing || !!credentials,
        onChange: this.handleChange,
        onClick: function onClick() {
          return _this3.handleClick();
        },
        value: name,
        error: validationError,
        showIconBeforeErrorMessage: true
      }), !credentials && (0, _preact.h)(_buttonControl.default, {
        variant: "brand",
        newStyle: true,
        size: "medium",
        type: "submit",
        title: "Create an OAuth2 client",
        isLoading: processing
      }), credentials && (0, _preact.h)(_Credentials.default, {
        credentials: credentials,
        onClickCopy: this.handleCopy
      }))), (0, _preact.h)("div", {
        className: "api-access-information"
      }, (0, _preact.h)("h4", {
        className: "header-title"
      }, "API access information"), (0, _preact.h)(_Table.default, {
        rows: this.getRows(),
        model: this.getModel()
      })), (0, _preact.h)(_List.default, {
        clients: clients,
        onRevokeButtonClick: function onRevokeButtonClick(e) {
          return _this3.handleRevoke(e);
        }
      }));
    }
  }]);
  return Form;
}(_preact.Component);

var _default = Form;
exports.default = _default;